import { isEmpty } from 'lodash';
import { createAPIService } from './api.service';
import { buildSearchValue } from 'domains/organization/organizations/utils';

export const REFERENCE_DATA_ENDPOINT = '/reference/data/api/v2';

const service = createAPIService(REFERENCE_DATA_ENDPOINT);

service.searchIndices = async params =>
  (await service.get('/search', { params: params })).data;

service.getOrganizations = async params => {
  const searchParams = {
    query: buildESQueryString(params.query),
    indexName: 'organizations',
    pageItems: 20,
    page: 0,
  };
  return (await service.get('/search', { params: searchParams })).data;
};

export const buildESQueryString = value => {
  let search = '';
  const organizationNameESQuery = 'names.languages.EN.full:';
  value = !isEmpty(value) ? value : '*';
  if (!isEmpty(value)) {
    const searchValue = buildSearchValue(value);
    search = `${organizationNameESQuery}${searchValue} `;
  }
  return search;
};

export default service;
